// removed by extract-text-webpack-plugin
module.exports = {"PhotogalleryItem":"PhotogalleryItem","PhotogalleryItem__link":"PhotogalleryItem__link","PhotogalleryItem__image":"PhotogalleryItem__image","PhotogalleryItem__video":"PhotogalleryItem__video","PhotogalleryItem__icon-open":"PhotogalleryItem__icon-open","PhotogalleryItem__icon-play":"PhotogalleryItem__icon-play","loaded":"loaded","mbTwoColumn":"mbTwoColumn","showLeft":"showLeft","showRight":"showRight"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/photogallery-item/styles.css
// module id = 814
// module chunks = 0 1